export enum AdditionalPropertyValueType {
  LIST = 'LIST',
  NUMBER = 'NUMBER',
  NUMBER_WITH_UNIT = 'NUMBER_WITH_UNIT',
}

export enum ComboVisibilityType {
  INVITE = 'INVITE',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export enum ElementType {
  MACRONUTRIENT = 'MACRONUTRIENT',
  MICRONUTRIENT = 'MICRONUTRIENT',
}

export enum ProgramType {
  SOIL_CROP_PROGRAM = 'SOIL_CROP_PROGRAM',
  TISSUE_CROP_PROGRAM = 'TISSUE_CROP_PROGRAM',
  TISSUE_GROWTH_PROGRAM = 'TISSUE_GROWTH_PROGRAM',
  FERTIGATION_CROP_PROGRAM = 'FERTIGATION_CROP_PROGRAM',
}

export enum SampleType {
  FRUIT_SAMPLE = 'FRUIT_SAMPLE',
  LEAF_SAMPLE = 'LEAF_SAMPLE',
  SOIL_SAMPLE = 'SOIL_SAMPLE',
  FERTIGATION_SAMPLE = 'FERTIGATION_SAMPLE',
}

export enum SortByOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface SortBy {
  field: string
  order: SortByOrder
}
